//black, gray  and white
export const white = '#FFF'
export const black = '#4D5656'
export const blackLight = '#3E3E3E'
export const dark = '#000000'
export const gray = '#D9D9D9'
export const grayLogo = '#A6ACAF'
export const grayLight = '#F0F3F4'
export const disable = '#E7E7E7'
export const transparent = 'transparent'

//gray
export const gray1 = '#F6F6F6'

//tones
export const red = '#E74C3C'
export const greenLight = '#F4F6F6'
export const greenDark = '#1E8449'
export const green1 = '#22A459'
export const yellowLight = '#F9E79F'
export const yellow1 = '#F6FFED'
export const yellowDark = '#FFB300'
export const lilaLight = '#F4ECF7'
export const lilaDark = '#633974'
export const lila1 = '#F6F6F6'
export const lila2 = '#F3ECF6'
export const lila3 = '#802FA3'

//text sizes
export const text_xxxs = 8
export const text_xxs = 10
export const text_xs = 12
export const text_sm = 14
export const text_md = 16
export const text_lg = 18
export const text_xl = 20
export const text_xxl = 24
export const text_xxxl = 26
export const text_big = 28

export const colors = {
  black: '#000',
  white: '#fff',
  primary: {
    primary100: '#FE4D0E',
    primary80: 'rgba(254, 77, 14, 0.8)',
    primary60: 'rgba(254, 77, 14, 0.6)',
    primary40: 'rgba(254, 77, 14, 0.4)',
    primary20: 'rgba(254, 77, 14, 0.2)',
    primary10: 'rgba(254, 77, 14, 0.1)'
  },
  secondary: {
    secondary100: '#FE9200',
    secondary80: 'rgba(254, 146, 0, 0.8)',
    secondary60: 'rgba(254, 146, 0, 0.6)',
    secondary40: 'rgba(254, 146, 0, 0.4)',
    secondary20: 'rgba(254, 146, 0, 0.1)',
    secondary10: 'rgba(254, 146, 0, 0.1)'
  },

  informative: {
    informative100: '#2563EB',
    informative80: 'rgba(37, 99, 235, 0.8)',
    informative60: 'rgba(37, 99, 235, 0.6)',
    informative40: 'rgba(37, 99, 235, 0.4)',
    informative20: 'rgba(37, 99, 235, 0.2)',
    informative10: 'rgba(37, 99, 235, 0.1)'
  },
  success: {
    success100: '#16A34A',
    success80: 'rgba(22, 163, 74, 0.8)',
    success60: 'rgba(22, 163, 74, 0.6)',
    success40: 'rgba(22, 163, 74, 0.4)',
    success20: 'rgba(22, 163, 74, 0.2)',
    success10: 'rgba(22, 163, 74, 0.1)'
  },
  warning: {
    warning100: '#FCBB16',
    warning80: 'rgba(252, 187, 22, 0.8)',
    warning60: 'rgba(252, 187, 22, 0.6)',
    warning40: 'rgba(252, 187, 22, 0.4)',
    warning20: 'rgba(252, 187, 22, 0.2)',
    warning10: 'rgba(252, 187, 22, 0.1)'
  },
  error: {
    error100: '#EB2327',
    error80: 'rgba(235, 35, 39, 0.8)',
    error60: 'rgba(235, 35, 39, 0.6)',
    error40: 'rgba(235, 35, 39, 0.4)',
    error20: 'rgba(235, 35, 39, 0.2)',
    error10: 'rgba(235, 35, 39, 0.1)'
  },
  neutral: {
    neutral900: '#1D1D1D',
    neutral800: '#262626',
    neutral700: '#313131',
    neutral600: '#3F3F3F',
    neutral500: '#454545',
    neutral400: '#6A6A6A',
    neutral300: '#828282',
    neutral200: '#A9A9A9',
    neutral100: '#C5C5C5',
    neutral50: '#ECECEC'
  }
}
